import autoSchedulingPatchesModule from '../../autoScheduling';

export default instance => {
  instance.attachEvent('onAfterTaskUpdate', (id, task) => {
    autoSchedulingPatchesModule.checkTimelineDates(task);
  });
};
